export const gridName = {
  schemaTable: "grid_schemas",
  settingsTable: "grid_settings",
  importTable: "grid_import",
  letterHeadTable: "grid_letter_head",
  printFormatTable: "grid_print_format",
  translationTable: "grid_translation",
  permissionTable: "grid_permission",
  roleTable: "grid_role",
  userTable: "grid_user",
  actionMasterTable: "grid_action_master",
  stateMasterTable: "grid_state_master",
  workflowTable: "grid_workflow",
  socialConfigurationTable: "grid_social_configuration",
  userPermissionsTable: "grid_user_permissions",
  notificationRecipientTable: "grid_notification_recipient",
  npsUserTable: "npsregistration",
  slaTable: "grid_sla_configuration",
  slaConfigurationTable: "grid_sla_configuration",
};
